function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.135,
    height: 28.129,
    viewBox: "0 0 28.135 28.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17325"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12523",
    d: "M-11630.35-3647.861v-3.62l.633-2.026 1.287-1.227h2.431l.728 1.227.574 1.2v4.055l-1.754.394h-3.9z",
    transform: "translate(11641.433 3675.182)",
    style: {
      fill: "#f37b89"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17324"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12519",
    d: "M9.209-511.973a2.984 2.984 0 0 0-2.138 2.133 29.238 29.238 0 0 0-.081 3.766v3.416l-2.75 1.386c-1.515.757-2.858 1.45-2.981 1.531A2.933 2.933 0 0 0 .2-498.1a61.856 61.856 0 0 0-.07 6.312l.016 5.984.145.274a1.564 1.564 0 0 0 .752.779l.338.183h24.975l.338-.183a1.564 1.564 0 0 0 .752-.779l.145-.274.016-5.984c.016-6.575.027-6.274-.312-6.962a2.727 2.727 0 0 0-.913-1.047c-.172-.118-1.515-.811-2.976-1.542l-2.664-1.327v-3.395c0-2.262-.021-3.5-.059-3.685a2.96 2.96 0 0 0-2.154-2.219c-.462-.11-8.874-.115-9.32-.008zm9.331 1.219a1.631 1.631 0 0 1 .87.843l.177.36v23.85l-1.139.016-1.144.011v-1.891c0-2.17-.027-2.385-.381-3.1a3.494 3.494 0 0 0-2.251-1.794 4.068 4.068 0 0 0-1.612 0 3.484 3.484 0 0 0-2.251 1.794c-.355.725-.381.94-.381 3.1v1.891l-1.139-.011-1.143-.015v-23.85l.14-.3a1.638 1.638 0 0 1 .682-.79c.478-.285.419-.279 5.006-.269l4.27.011zM6.991-493.516v7.843H4.38c-2.9 0-2.885 0-3.051-.349-.081-.167-.086-.757-.075-6l.016-5.818.177-.36a1.668 1.668 0 0 1 .4-.548c.188-.15 4.974-2.6 5.1-2.605.028-.006.044 3.524.044 7.837zm16.282-6.607c2.691 1.354 2.783 1.407 3.051 1.982l.14.3.016 5.818c.011 5.243.005 5.834-.075 6-.167.349-.15.349-3.051.349h-2.612v-7.843c0-4.313.011-7.843.027-7.843s1.144.56 2.504 1.237zm-8.584 8.863a2.392 2.392 0 0 1 1.359 1.434 8.014 8.014 0 0 1 .1 2.219v1.907h-4.564l-.016-1.719c-.016-1.869.016-2.224.242-2.707a2.818 2.818 0 0 1 .972-1.021 2.431 2.431 0 0 1 1.907-.113z",
    transform: "translate(.2 512.376)",
    style: {
      fill: "#6f7e8e",
      stroke: "#6f7e8e",
      strokeWidth: ".65px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12520",
    d: "M213.29-447.9a.682.682 0 0 0-.231.279 23.235 23.235 0 0 0-.059 2.5c0 2.595 0 2.616.349 2.777a.819.819 0 0 0 .242.086.819.819 0 0 0 .242-.086c.3-.14.349-.322.349-1.332v-.892h2.256v.892c0 1.01.048 1.192.349 1.332a.4.4 0 0 0 .483 0c.349-.161.349-.177.349-2.783 0-2.578-.005-2.638-.317-2.793a.694.694 0 0 0-.274-.086.624.624 0 0 0-.516.349 3.791 3.791 0 0 0-.075 1.074v.886h-2.256v-.886c0-1-.048-1.2-.317-1.338a.51.51 0 0 0-.574.021z",
    transform: "translate(-201.243 451.766)",
    style: {
      fill: "#da5968"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12521",
    d: "M192.338-299.039a.627.627 0 0 0-.338.51.624.624 0 0 0 .349.516 56.43 56.43 0 0 0 6.177 0 .624.624 0 0 0 .349-.516.624.624 0 0 0-.349-.516 56.617 56.617 0 0 0-6.188.006z",
    transform: "translate(-181.371 310.889)",
    style: {
      fill: "#3970b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12522",
    d: "M192.338-235.039a.627.627 0 0 0-.338.51.624.624 0 0 0 .349.516 56.43 56.43 0 0 0 6.177 0 .624.624 0 0 0 .349-.516.624.624 0 0 0-.349-.516 56.617 56.617 0 0 0-6.188.006z",
    transform: "translate(-181.371 250.326)",
    style: {
      fill: "#3970b0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.6342ce977c5f4555e553ce4e34ff434a.svg";
export { ForwardRef as ReactComponent };